import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { useAuth } from "@/firebase/useAuth";

interface RequireAuthProps {
  children: ReactNode;
}

/**
 * Basic authentication check - just verifies user is logged in.
 * Does NOT check for parental approval (use RequireApproval for that).
 */
export default function RequireAuth({ children }: RequireAuthProps) {
  const location = useLocation();
  const { user, loading: authLoading } = useAuth();

  if (authLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-950 text-slate-200">
        Checking your session…
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <>{children}</>;
}
